import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { useAuth } from '@/hooks/use-auth';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

type AuthStep = 'signIn' | 'signUp' | 'resetPassword';

interface ResetPasswordFormProps {
  onSwitchStep: (step: AuthStep) => void;
  onClose: () => void;
}

export function ResetPasswordForm({ onSwitchStep, onClose }: ResetPasswordFormProps) {
  const { passwordReset } = useAuth();
  const { toast } = useToast();
  const [email, setEmail] = useState('');

  const handleResetPassword = (e: React.FormEvent) => {
    e.preventDefault();
    passwordReset.mutate(email, {
      onSuccess: (data: { message: string }) => {
        toast({
          title: 'Восстановление пароля',
          description: data.message || 'Проверьте почту для дальнейших инструкций',
        });
        onClose();
      },
    });
  };

  return (
    <form onSubmit={handleResetPassword}>
      <div className="space-y-2 mb-4">
        <Input
          type="email"
          placeholder="Электронная почта"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <Button type="submit" className="w-full" disabled={passwordReset.isPending} data-goal-id="reset_password_clicked">
        {passwordReset.isPending ? 'Отправка...' : 'Отправить'}
      </Button>
      <div className="text-center mt-4">
        <Button variant="link" onClick={() => onSwitchStep('signIn')}>
          Вернуться ко входу
        </Button>
      </div>
    </form>
  );
}
